function applyGold() {
  var style = document.getElementById('gold-style');
  if (!style) {
    style = document.createElement('style');
    style.id = 'gold-style';
    style.innerHTML = `
      .gold-shine {
        background: linear-gradient(105deg, #7A5C1E 0%, #C9A435 18%, #F5D97A 30%, #E8C04A 40%, #B8860B 52%, #F0D060 62%, #FFFFFF 68%, #D4A520 76%, #8B6914 88%, #C9A435 100%) !important;
        background-size: 300% 300% !important;
        -webkit-background-clip: text !important;
        -webkit-text-fill-color: transparent !important;
        background-clip: text !important;
        transition: background-position 0.3s ease-out !important;
        display: inline-block;
      }
    `;
    document.head.appendChild(style);
  }
  document.querySelectorAll('h1').forEach(function(el) {
    el.classList.add('gold-shine');
  });
}

applyGold();
document.addEventListener('shopify:section:load', applyGold);

function moveGold(x, y) {
  var pos = x + '% ' + y + '%';
  document.querySelectorAll('.gold-shine').forEach(function(el) {
    el.style.setProperty('background-position', pos, 'important');
  });
  document.querySelectorAll('#goldGradient, #goldGradientBand, #goldGradientNL').forEach(function(g) {
    if (g) {
      g.setAttribute('x1', (x - 20) + '%');
      g.setAttribute('x2', (x + 80) + '%');
    }
  });
}

// Desktop
document.addEventListener('mousemove', function(e) {
  var x = (e.clientX / window.innerWidth) * 100;
  var y = (e.clientY / window.innerHeight) * 100;
  moveGold(x, y);
});

// Mobile — touchmove
document.addEventListener('touchmove', function(e) {
  var touch = e.touches[0];
  var x = (touch.clientX / window.innerWidth) * 100;
  var y = (touch.clientY / window.innerHeight) * 100;
  moveGold(x, y);
}, { passive: true });